export const sendEmailWithLink = (title = 'Constellium') => {
  window.location = `mailto:?subject=${title}&body=${window.location.href}`
}

export const sendEmailWithDocumentLink = (link, title = 'Constellium') => {
  window.location = `mailto:?subject=${title}&body=${encodeURI(link)}`
}
